import { isLayerEnvironment } from '../../layerEnvironments'
import { type Demo } from '../../Root'
import { type RawDemoData } from './types'

export const RECENT_DEMOS_KEY = 'admin_recent_demos'
export const MAX_RECENT_DEMOS = 5

export function getRecentDemos(): string[] {
  try {
    const stored = localStorage.getItem(RECENT_DEMOS_KEY)
    if (stored) {
      const parsed = JSON.parse(stored)
      if (Array.isArray(parsed)) {
        return parsed.slice(0, MAX_RECENT_DEMOS)
      }
    }
  } catch { }
  return []
}

export function addRecentDemo(clientName: string): void {
  try {
    const recent = getRecentDemos().filter(name => name !== clientName)
    recent.unshift(clientName)
    localStorage.setItem(
      RECENT_DEMOS_KEY,
      JSON.stringify(recent.slice(0, MAX_RECENT_DEMOS)),
    )
  } catch { }
}

export function isValidHex(hex: string): boolean {
  const regex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/
  return regex.test(hex)
}

export function mapDemo(data: RawDemoData): Demo {
  return {
    id: data.id,
    clientName: data.client_name,
    brandColorHex: data.brand_color_hex,
    brandColorLightHex: data.brand_color_light_hex,
    brandColorDarkHex: data.brand_color_dark_hex,
    brandColorTextHex: data.brand_color_text_hex,
    brandLogoUrl: data.brand_logo_url,
    businessId: data.business_id,
    datePickerMode: data.date_picker_mode,
    hasImportedRevenueData: data.has_imported_revenue_data,
    bookkeepingOn: data.bookkeeping_on ?? false,
    showDescriptions: data.show_descriptions ?? true,
    showReceiptUploads: data.show_receipt_uploads ?? true,
    showInvoicesTab: data.show_invoices_tab ?? false,
    showCustomerVendor: data.show_customer_vendor ?? false,
    defaultToMobile: data.default_to_mobile ?? false,
    useSolopreneurLayout: data.use_solopreneur_layout ?? false,
    enableTimeTracking: data.enable_time_tracking ?? false,
    translateToSpanish: data.translate_to_spanish,
    hasCredentialOverride: data.has_credential_override,
    layerEnvironmentOverride: isLayerEnvironment(data.layer_environment_override)
      ? data.layer_environment_override
      : undefined,
    archivedAt: data.archived_at ?? undefined,
  }
}
